import React, { useState, useEffect } from 'react';
import { TreeSelect } from 'clad';
import treeSelectEventModel from './model/treeSelectEventModel';

const { TreeNode } = TreeSelect;

const TreeSelectEvent = React.forwardRef((props, ref) => {
    const { value, onChange } = props;

    const [data, setData] = useState({
        data: null,
        count: null,
        loading: null,
        loaded: false
    });

    const parents = {};
    let treeData = [];

    if (data.data) {
        data.data.forEach(row => {
            if (!row.parent) {
                row.parent = 'Features';
            }
            const title = (
                <div>
                    <p style={{ fontSize: '14px', fontWeight: 600 }}>
                        {row.name}
                    </p>
                    <p style={{ fontSize: '11px' }}>{row.description}</p>
                </div>
            );
            if (parents[row.parent]) {
                parents[row.parent].push(
                    <TreeNode value={row.key} title={title} key={row.key} />
                );
            } else {
                parents[row.parent] = [];
                parents[row.parent].push(
                    <TreeNode value={row.key} title={title} key={row.key} />
                );
            }
        });

        treeData = Object.keys(parents).map(parent => {
            return (
                <TreeNode
                    value={parent}
                    title={parent}
                    key={parent}
                    selectable={false}
                >
                    {parents[parent]}
                </TreeNode>
            );
        });
    }

    const handleChange = value => {
        if (value) {
            const event = data.data.find(data => data.key === value);
            const newValue = {
                idEvent: value,
                scopes: event && event.scopes ? event.scopes : []
            };

            if (onChange) {
                onChange(newValue);
            }
        } else {
            if (onChange) {
                onChange(value);
            }
        }
    };

    const handleFetch = async () => {
        setData({
            ...data,
            loading: true
        });

        const result = await treeSelectEventModel.listTreeSelectEvent();

        setData({
            ...result,
            loading: false,
            loaded: true
        });
    };

    useEffect(() => {
        handleFetch();
    }, []);

    const handleFilter = (inputValue, treeNode) => {
        const objTitle = treeNode.props.title.props?.children;
        if (objTitle) {
            const title = objTitle[0].props.children.toLowerCase();
            const result = title.indexOf(inputValue.toLowerCase()) !== -1;
            return result;
        }
    };

    return (
        <TreeSelect
            showSearch
            style={{ width: '100%' }}
            value={value ? value.idEvent : undefined}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder="Please select"
            allowClear
            onChange={handleChange}
            filterTreeNode={handleFilter}
        >
            {treeData}
        </TreeSelect>
    );
});

export default TreeSelectEvent;
